export const locales = ["en", "zh", "ja", "sv", "de", "fr", "es"] as const;
export type Locale = (typeof locales)[number];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isLocale = (string: any): string is Locale =>
  locales.includes(string);
